<template>
  <v-app-bar app :class="classBg">
    <v-container class="container-size">
      <v-row justify="center" style="margin:0px;">
        <span v-if="this.type === 'finance'" @click="handleClickMenu('42Monks')" class="font-logos" style="opacity:1; font-size: 24px; padding-top: 8px; padding-left: 14px;margin-top:0px; color: black; cursor: pointer;">42MONKS CAPITAL</span>

        <v-spacer></v-spacer>
        <div class="hidden-md-and-down" style="padding-top: 8px">
          <v-btn text plain :ripple="false" :class="[classMenuButton, { 'active': menuOpenProjects }]">
            Products
            <v-icon :class="classIconStyleMenu">{{ menuOpenProjects ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon>
            <v-menu activator="parent" @click:activator="toggleMenuProjects" v-model="menuOpenProjects"
              @click:outside="menuOpenProjects = false" :no-click-animation="true" :open-delay="0" transition="none">
              <v-list :class="classListMenu" density="compact">
                <v-list-item :ripple="false" v-for="(item, index) in itemsProjects" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                  <template v-slot:append>
                    <v-icon :icon="item.icon" :class="classIconStyleMenuIn"></v-icon>
                  </template>
                  <v-list-item-title :class="classListItem" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
          <v-btn text plain :ripple="false" :class="[classNoMenuButton, { 'active': false }]"  @click="handleClickMenu('About')">
            About
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer> 
        <v-spacer></v-spacer>
        <div style="padding-top: 8px" >
        <v-btn text plain :ripple="false" :class="classBtnIconStyle" @click="handleClickMenu('Office')">
          Family Office 
          <v-icon :class="classIconStyle"> mdi-arrow-right-top</v-icon>
        </v-btn>
          <v-btn text plain :ripple="false" :class="classBtnIconBorderStyle" @click="handleClickMenu('Log')">
          Log in
          <v-icon :class="classIconStyleHover"> mdi-arrow-right-top </v-icon>
        </v-btn>
        <v-btn @click="sendDrawer()" style="margin-top:-8px;" icon text :ripple="false" class="hidden-lg-and-up">
          <v-icon :class="classIconMenu" large>mdi-menu</v-icon>
        </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script>

export default {
  name: 'NavBar',
  props: ['styleType'],
  components: {

  },

  data: () => ({
    scrollPosition: 0,
    menuOpenCompany: false,
    menuOpenProjects: false,
    menuOpenAPI: false,
    type: 'standard',
    classBg: { 'bg_std_color': true },
    classListMenu: { 'bg_std_listmenu': true },
    itemsProjects: [
        { title: 'Family Office', link: 'FamilyOffice', icon: '' },
        { title: 'Generational Wealth Management', link: 'FortyTwo', icon: ''},
        { title: 'Quantitative Trading', link: 'Quant', icon: ''},
      ],
  }),
  beforeMount() {
    this.type = this.styleType;
  },
  mounted() {
        window.addEventListener('scroll', this.updateScroll);
        this.classBg = {
          'bg_std_color_finance': this.type === 'finance',
        };
        this.classListMenu = {
          'bg_std_listmenu_finance': this.type === 'finance',
        }
  },
  computed: {
    classListItem() {
      return this.generateListItemClass('listmenuitem', this.type, 'bg_std_');
    },
    classIconStyleHover() {
    return this.getStyleClasses('mdi-18px icon-hover', 'icon-style2', this.type);
    },
    classIconStyle() {
      return this.getStyleClasses('mdi-18px', 'icon-style', this.type);
    },
    classBtnIconStyle() {
      return this.getStyleClasses('text-none hidden-md-and-down', 'menu-btn-icon', this.type);
    },
    classBtnIconBorderStyle() {
      return this.getStyleClasses('text-none hidden-md-and-down', 'menu-btn-icon-border', this.type);
    },
    classIconMenu() {
      return this.getStyleClasses('', 'icon-menu', this.type);
    },
    classIconStyleMenu() {
      return this.getStyleClasses('mdi-18px', 'icon-menu-drop', this.type);
    },
    classMenuButton() {
      return this.getStyleClasses('text-none', 'menu-btn', this.type);
    },
    classMenuButtonShort() {
      return this.getStyleClasses('text-none', 'menu-btns', this.type);
    },
    classNoMenuButton() {
      return this.getStyleClasses('text-none', 'nomenu-btn', this.type);
    },
    classIconStyleMenuIn() {
      return this.getStyleClasses('mdi-18px', 'icon-menu-drop-in', this.type);
    },
  },
  watch: {
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.updateScroll);
  },
  created() {

  },
  methods: {
    generateListItemClass(classSuffix, styleT, prefix = 'bg_std_') {
      return {
        [`${prefix}${classSuffix}`]: styleT === 'standard',
        [`${prefix}${classSuffix}_${styleT}`]: styleT !== 'standard',
      };
    },
    getStyleClasses(primaryClass, secondaryClass, styleT) {
      return {
        [primaryClass]: true,
        [`${secondaryClass}_${styleT}`]: styleT !== 'standard',
        [`${secondaryClass}`]: styleT === 'standard',
      };
    },
    gotoroot() {
      if (this.$route.name != '42Monks') {
        this.$router.push({ name: '42Monks' });
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (this.scrollPosition > 20) {
        this.classBg = {
          'bg_scroll_color_finance': this.type === 'finance',
        };
        this.classListMenu = {
          'bg_scroll_listmenu_finance': this.type === 'finance',
        }
      } else {
        this.classBg = {
          'bg_std_color_finance': this.type === 'finance',
        };
        this.classListMenu = {
          'bg_std_listmenu_finance': this.type === 'finance',
        }
      }
    },
    sendDrawer() {
      this.emitter.emit('hamburger')
    },
    toggleMenuProjects() {
      this.menuOpenProjects = !this.menuOpenProjects
    },
    toggleMenuCompany() {
      this.menuOpenCompany = !this.menuOpenCompany
    },
    toggleMenuAPI() {
      this.menuOpenAPI = !this.menuOpenAPI
    },
    handleClick(){
      // Nothing..
    },
    handleClickMenu(link){
      if (link === 'Office'){
        window.open('https://office.42monks.com/','_blank');
      } else if (link === 'Log') {
        window.open('https://selene.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';
@use './css/styles_finance.scss';


.container-size {
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 960px) {
    max-width: 1608px;
  }
}

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

:deep(.v-list-item--active > .v-list-item__overlay), 
:deep(.v-list-item[aria-haspopup=menu][aria-expanded=true] > .v-list-item__overlay) {
  opacity: 0;
}

</style>
